module.exports = __webpack_public_path__ + "img/FISSO_GAS.10cea1ee.png";